import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import MetaTags from "../lib/MetaTags";

export default function NotFound() {
  return (
    <Layout>
      <MetaTags title="Not Found" description="Page not found." />
      <section className="ceg-container py-24 text-center">
        <p className="ceg-overline">404</p>
        <h1 className="font-['Outfit'] font-black tracking-tighter text-6xl md:text-8xl mt-4">Lost in transit.</h1>
        <p className="mt-4 text-lg text-[#5C5C5C] max-w-md mx-auto">The page you requested wasn't found. It may have moved or been retired.</p>
        <Link to="/" className="ceg-btn-primary mt-8" data-testid="notfound-home">Back to home</Link>
      </section>
    </Layout>
  );
}
